export const COUNTRY_GET = 'COUNTRY_GET'
export const COUNTRY_GET_SUCCESS = 'COUNTRY_GET_SUCCESS'
export const COUNTRY_GET_FAILURE = 'COUNTRY_GET_FAILURE'
export const COUNTRY_GET_FORCE = 'COUNTRY_GET_FORCE'